/**
 * ResetPasswordLinkModal
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { QRCodeSVG } from 'qrcode.react';
import { useApi2fetch } from 'containers/Api2/index.js';
import { PARENT_ROLE } from 'containers/User/constants.js';
import CopyButton from 'components/interaction/CopyButton/index.jsx';
import AlertList from 'components/AlertList/index.jsx';
import Spinner from 'components/Spinner/index.jsx';
import messages from '../messages.js';

function ResetPasswordLinkModal(props) {
  const { user, onHide } = props;
  const api2fetch = useApi2fetch();
  const [link, setLink] = useState();
  const show = user?.roleType === PARENT_ROLE;
  const { id, roleType } = user || {};

  async function getLink() {
    const options = {
      method: 'POST',
      url: 'sa/users/getpasswordlink',
      body: { roleType, userId: id },
      version: 2,
    };
    const response = await api2fetch(options);
    setLink(response?.url);
  }

  useEffect(() => {
    if (show) {
      getLink();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={Boolean(user)} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          <FormattedMessage {...messages.generatePasswordResetLink} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertList />
        <p className="text-center mx-0 mx-sm-5"><FormattedMessage {...messages.copyResetLink} /></p>
        { link ? (
          <>
            <div className="mb-4 text-center text-break mx-0 mx-sm-5"><a href={link}>{link}</a></div>
            <div className="text-center mb-4 ">
              <CopyButton icon variant="light" text={link} />
            </div>
            <div className="text-center my-5 ">
              <QRCodeSVG value={link} />
            </div>
          </>

        ) : <Spinner />}
      </Modal.Body>
    </Modal>
  );
}

ResetPasswordLinkModal.propTypes = {
  user: PropTypes.object,
  onHide: PropTypes.func,
};

export default ResetPasswordLinkModal;
